function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { CardSet } from '../apricot';
import Enrollments from './panels/Enrollments';
import ExamRegistrations from './panels/ExamRegistrations';
import Order from './panels/Order';
import Cost from './panels/Cost';
import styles from '../../../sass/status.module.scss';
function StatusPanels(_ref) {
  var studentRegistrations = _ref.studentRegistrations,
    examRegistrations = _ref.examRegistrations,
    cost = _ref.cost,
    school = _ref.school,
    history = _ref.history,
    hideOrderPanel = _ref.hideOrderPanel,
    hideStudentRegistrations = _ref.hideStudentRegistrations,
    AdditionalCostComponent = _ref.AdditionalCostComponent;
  var hasUnsubmittedChanges = (examRegistrations === null || examRegistrations === void 0 ? void 0 : examRegistrations.changeOrderStatus) === 'NOT_SUBMITTED';
  var isSubmitted = (examRegistrations === null || examRegistrations === void 0 ? void 0 : examRegistrations.orderStatus) === 'SUBMITTED';
  var cards = [{
    title: 'Exam Registrations',
    content: /*#__PURE__*/React.createElement(ExamRegistrations, _extends({}, examRegistrations, {
      history: history
    }))
  }, {
    title: 'Cost',
    content: /*#__PURE__*/React.createElement(Cost, _extends({}, cost, {
      AdditionalCostComponent: AdditionalCostComponent
    }))
  }];
  // If displaying student registrations panel, add to beginning of array
  if (!hideStudentRegistrations) {
    cards.unshift({
      title: 'Student Registrations',
      content: /*#__PURE__*/React.createElement(Enrollments, studentRegistrations)
    });
  }
  // If displaying order panel, add to end of array
  if (!hideOrderPanel) {
    cards.push({
      title: 'Orders',
      content: /*#__PURE__*/React.createElement(Order, _extends({}, examRegistrations, school, {
        history: history
      })),
      className: "".concat(styles['order-panel']).concat(!isSubmitted || hasUnsubmittedChanges ? ' cb-blue5-bg cb-white-color' : '')
    });
  }
  return /*#__PURE__*/React.createElement(CardSet, {
    cardMargin: !hideOrderPanel ? '24' : '32',
    cards: cards
  });
}
export default StatusPanels;